import * as userServ from "../services/userService";

export default {
  namespaced: true,
  state: {
    isLoading: false, //是否正在进行远程处理
    isLogined: false, //是否登录过
    user: null //当前登录的用户
  },
  getters: {
    isBeginning(state) {
      return !state.isLoading && !state.isLogined;
    }
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload || null;
      state.isLogined = true;
    },
    setIsLoaing(state, payload) {
      state.isLoading = payload;
    }
  },
  actions: {
    async login(context, { loginId, loginPwd }) {
      context.commit("setIsLoaing", true);
      const resp = await userServ.login(loginId, loginPwd);
      context.commit("setIsLoaing", false);
      context.commit("setUser", resp.data);
      return resp.data;
    },
    async whoAmI(context) {
      context.commit("setIsLoaing", true);
      const resp = await userServ.whoAmI();
      context.commit("setIsLoaing", false);
      context.commit("setUser", resp.data);
      return resp.data;
    },
    async loginOut() {
      userServ.loginOut();
    }
  }
};
